import { render, staticRenderFns } from "./RegistryStatement.vue?vue&type=template&id=ab403f28"
import script from "./RegistryStatement.vue?vue&type=script&lang=js"
export * from "./RegistryStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports